// ─── Albums ───────────────────────────────────────────────────────────────────

export async function getMyAlbums() {
  const res = await fetch("/api/albums/my", { credentials: "include" });
  const data = await res.json().catch(() => []);
  if (!res.ok) throw new Error(data?.error || "Erreur chargement albums");
  return data;
}

export async function getSharedWithMe() {
  const res = await fetch("/api/albums/shared-with-me", { credentials: "include" });
  const data = await res.json().catch(() => []);
  if (!res.ok) throw new Error(data?.error || "Erreur chargement albums partagés");
  return data;
}

export async function getAlbum(id) {
  const res = await fetch(`/api/albums/${id}`, { credentials: "include" });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.message || "Erreur chargement album");
  return data;
}

export async function createAlbum(name, description = "") {
  const res = await fetch("/api/albums", {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ name, description }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.message || "Erreur création album");
  return data;
}

export async function updateAlbum(id, name, description) {
  const res = await fetch(`/api/albums/${id}`, {
    method: "PUT",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ name, description }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.message || "Erreur mise à jour album");
  return data;
}

export async function deleteAlbum(id) {
  const res = await fetch(`/api/albums/${id}`, { method: "DELETE", credentials: "include" });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.message || "Erreur suppression album");
  return data;
}

export async function addMediaToAlbum(albumId, mediaIds) {
  const res = await fetch(`/api/albums/${albumId}/media`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ media_ids: mediaIds }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.message || "Erreur ajout médias");
  if (data.added === 0) throw new Error("Aucun média lié (accès refusé ou IDs invalides)");
  return data;
}

export async function removeMediaFromAlbum(albumId, mediaId) {
  const res = await fetch(`/api/albums/${albumId}/media/${mediaId}`, {
    method: "DELETE",
    credentials: "include",
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.message || "Erreur retrait média");
  return data;
}

export async function shareAlbumWithUser(albumId, userEmail) {
  const res = await fetch(`/api/albums/${albumId}/shares`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ user_email: userEmail }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.message || "Erreur partage");
  return data;
}

export async function shareAlbumWithGroup(albumId, groupId) {
  const res = await fetch(`/api/albums/${albumId}/shares`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ group_id: groupId }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.message || "Erreur partage groupe");
  return data;
}

export async function removeShare(albumId, shareId) {
  const res = await fetch(`/api/albums/${albumId}/shares/${shareId}`, {
    method: "DELETE",
    credentials: "include",
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.message || "Erreur suppression partage");
  return data;
}

// ─── Groupes ──────────────────────────────────────────────────────────────────

export async function getMyGroups() {
  const res = await fetch("/api/groups/my", { credentials: "include" });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.error || "Erreur chargement groupes");
  return data;
}

export async function createGroup(name) {
  const res = await fetch("/api/groups", {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ name }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.message || "Erreur création groupe");
  return data;
}

export async function updateGroup(id, name) {
  const res = await fetch(`/api/groups/${id}`, {
    method: "PUT",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ name }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.message || "Erreur mise à jour groupe");
  return data;
}

export async function deleteGroup(id) {
  const res = await fetch(`/api/groups/${id}`, { method: "DELETE", credentials: "include" });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.message || "Erreur suppression groupe");
  return data;
}

export async function addMemberToGroup(groupId, userEmail) {
  const res = await fetch(`/api/groups/${groupId}/members`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ user_email: userEmail }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.message || "Erreur ajout membre");
  return data;
}

export async function removeMemberFromGroup(groupId, userId) {
  const res = await fetch(`/api/groups/${groupId}/members/${userId}`, {
    method: "DELETE",
    credentials: "include",
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.message || "Erreur retrait membre");
  return data;
}
